/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SignupStep } from './';
import {
    SignupStepFromJSON,
    SignupStepFromJSONTyped,
    SignupStepToJSON,
} from './';

/**
 * 
 * @export
 * @interface StepUserQualification
 */
export interface StepUserQualification extends SignupStep {
}

/**
 * Check if a given object implements the StepUserQualification interface.
 */
export function instanceOfStepUserQualification(value: object): value is StepUserQualification {
    return true;
}

export function StepUserQualificationFromJSON(json: any): StepUserQualification {
    return StepUserQualificationFromJSONTyped(json, false);
}

export function StepUserQualificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): StepUserQualification {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...SignupStepFromJSONTyped(json, ignoreDiscriminator),
    };
}

export function StepUserQualificationToJSON(value?: StepUserQualification | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...SignupStepToJSON(value, true),
    };
}

